import React, { useEffect } from "react";
import useAuth from "../../../hooks/useAuth";
import Metrics from "../../../components/Dashboard/MetricsCards";
import DashboardTitles from "../../../components/Dashboard/Titles";

const Dashboard = () => {
  useEffect(() => {
    document.title = "Dashboard - Snilink";
  }, []);
  const { auth } = useAuth();
  return (
    <>
      <DashboardTitles username={auth.username} />
      <Metrics auth={auth} />
      <Message />
    </>
  );
};

export default Dashboard;

function Message() {
  return (
    <>
      <div className="text-accent-400 text-sm">
        Application is under maintenance stay tuned for upcoming features :)
      </div>
    </>
  );
}
